export class MobileFeedModel {

    public mob_feed_id: any;
    public pr_status_id: any;
    public transaction_type_name: string;
    public transaction_complete_date: string;
    public transaction_complete_from_date: string;
    public transaction_complete_to_date: string;
    public account_start_date: string;
    public line_add_create_datetime: string;
    public line_disco_create_datetime: string;
    public account_number: string;
    public first_name: string;
    public last_name: string;
    public employee_id: string;
    public account_sales_rep_id: string;
    public account_sales_channel: string;
    public subscriber_number: string;

    public msisdn: string;
    public order_id: string;
    public line_status: string;
    public dayslineaddedfromacctstart: string;
    public days_line_active: string;
    public plan_description: string;
    public fixed_line_cust: string;

    public trans_type: string;
    public elig_revenue: number;
    public sim_activation_date: string;
    public line_add_status: string;
    public line_disco_status: string;
    public service_plan: string;
    public total_count: number;
    public line_sales_rep_id: string;
    public status: string;
    public mobilefeedid: string;
    public created_by: string;
    public created_on: Date;
    public last_modified_by: string;

    public field_value: string;
    public field_name: string;

    public ported_flag: string;
    public rec_type: string;
    public completed_portin_flag: number;
    public device_type: string;
    public originalamount: number;
    public port_flag: string;

    constructor() {
        this.account_sales_channel = null;
        this.ported_flag = null;
        this.rec_type = null;
        this.completed_portin_flag = null;
        this.device_type = null;
        this.originalamount = null;
        this.port_flag = null;

        this.field_value = null;
        this.field_name = null;
        this.last_modified_by = null;
        this.created_on = null;
        this.created_by = null;
        this.mobilefeedid = null;
        this.status = null;
        this.trans_type = null;
        this.elig_revenue = null;
        this.sim_activation_date = null;
        this.line_add_status = null;
        this.line_disco_status = null;
        this.service_plan = null;
        this.total_count = null;
        this.line_sales_rep_id = null;

        this.mob_feed_id = null;
        this.pr_status_id = null;
        this.transaction_type_name = null;
        this.transaction_complete_date = null;
        this.account_start_date = null;
        this.line_add_create_datetime = null;
        this.line_disco_create_datetime = null;
        this.account_number = null;
        this.first_name = null;
        this.last_name = null;
        this.employee_id = null;
        this.account_sales_rep_id = null;
        this.subscriber_number = null;
        this.msisdn = null;
        this.order_id = null;
        this.line_status = null;
        this.dayslineaddedfromacctstart = null;
        this.days_line_active = null;
        this.plan_description = null;
        this.fixed_line_cust = null;
    }
}